import _ from 'lodash';

const sortRestaurants = (restaurants, sort) => {
    let sorted= [];
    switch (sort) {
        case 'restaurantName':
            sorted = _.orderBy(restaurants, [restaurant => restaurant.restaurantName.toLowerCase()], ['asc']);
            break;
        case 'highestRating':
            sorted= _.orderBy(restaurants, 'rating', ['desc']);
            break;
        case 'highestPrice':
            sorted= _.orderBy(restaurants, 'maxPrice', ['desc']);
            break;
        case 'lowestPrice':
            sorted= _.orderBy(restaurants, 'maxPrice', ['asc']);
            break;
        default:
            sorted= _.orderBy(restaurants, 'address.distance', ['asc']);
    }

    let closedRestaurants= _.filter(sorted, {isOpen: 0});
    let openRestaurants = _.filter(sorted, {isOpen: 1});

    return openRestaurants.concat(closedRestaurants);
}

export { sortRestaurants };